import getAllSharePointLinks from '../utils/getAllSharePointLinks';
import handleBeforePasteEvent from '../utils/handleBeforePasteEvent';
import handleSharePointLink from '../utils/handleSharePointLink';
import isLinkRemovalRelatedEvent from '../utils/isLinkRemovalRelatedEvent';
import isSharePointLink from '../utils/isSharePointLink';
import processContentChangedFromSetContent from '../utils/processContentChangedFromSetContent';
import trySetIdAndClassName from '../utils/trySetIdAndClassName';
import { removeComposeOnlyContent } from 'owa-attachment-link-common';
import { isContextMenuOpen, removeLinkContextMenu, showLinkContextMenu } from 'owa-compose-link';
import { getNumberOfSharingLinks, getSharingLink } from 'owa-link-data';
import { trace } from 'owa-trace';
var RESIZE_EVENT_NAME = 'resize';
var LinkPlugin = /** @class */ (function () {
    function LinkPlugin(viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, scrollAdapter) {
        var _this = this;
        this.viewState = viewState;
        this.parentItemIdWrapper = parentItemIdWrapper;
        this.infoBarAddHandler = infoBarAddHandler;
        this.infoBarRemoveHandler = infoBarRemoveHandler;
        this.scrollAdapter = scrollAdapter;
        this.name = 'Link';
        this.tryGetAllSPLinks = function () {
            if (!_this.pendingSPLinksTask) {
                _this.pendingSPLinksTask = setTimeout(function () {
                    _this.getAllSPLinks();
                }, 500);
            }
        };
        this.onScrollOrResize = function () {
            if (getNumberOfSharingLinks() > 0) {
                removeLinkContextMenu();
            }
        };
        this.processedLinkIds = [];
    }
    LinkPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
        this.onCutDisposer = this.editor.addDomEventHandler('cut', this.tryGetAllSPLinks);
        this.scrollAdapter.addScrollEventListener(this.onScrollOrResize);
        window.addEventListener(RESIZE_EVENT_NAME, this.onScrollOrResize);
    };
    LinkPlugin.prototype.onPluginEvent = function (event) {
        if (event.eventType === 8 /* BeforePaste */) {
            handleBeforePasteEvent(event, this, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler, this.processedLinkIds);
        }
        else if (event.eventType === 6 /* ContentChanged */) {
            var contentChangedEvent = event;
            if ((contentChangedEvent.source === "AutoLink" /* AutoLink */ ||
                contentChangedEvent.source === "CreateLink" /* CreateLink */) &&
                contentChangedEvent.data &&
                contentChangedEvent.data instanceof HTMLAnchorElement) {
                if (!isSharePointLink(contentChangedEvent.data.href)) {
                    return;
                }
                trySetIdAndClassName(contentChangedEvent.data);
                this.processedLinkIds.push(contentChangedEvent.data.id);
                handleSharePointLink(this, contentChangedEvent.source === "AutoLink" /* AutoLink */, contentChangedEvent.data, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler);
            }
            else {
                processContentChangedFromSetContent(event, this, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler, this.processedLinkIds);
            }
        }
        else if (event.eventType === 7 /* ExtractContent */) {
            var extractContentEvent = event;
            extractContentEvent.content = removeComposeOnlyContent(extractContentEvent.content);
            return;
        }
        else if (getNumberOfSharingLinks() > 0 &&
            (event.eventType === 2 /* KeyUp */ ||
                (event.eventType === 5 /* MouseUp */ && this.isMouseLeftClick(event)))) {
            var selectionNode = this.editor.getSelectionRange();
            if (selectionNode) {
                var startNode = selectionNode.startContainer;
                var endNode = selectionNode.endContainer;
                var parentNode = startNode.parentNode;
                var anchorElement = parentNode;
                if (parentNode.nodeName.toLowerCase() === 'a' &&
                    startNode === endNode &&
                    this.isSharingLink(anchorElement.id)) {
                    !isContextMenuOpen(anchorElement.id) && showLinkContextMenu(anchorElement);
                }
                else {
                    removeLinkContextMenu();
                }
            }
        }
        this.processLinkRemovalRelatedEvents(event);
    };
    LinkPlugin.prototype.isMouseLeftClick = function (event) {
        return event.rawEvent.button === 0;
    };
    LinkPlugin.prototype.processLinkRemovalRelatedEvents = function (event) {
        if (isLinkRemovalRelatedEvent(event, this.editor)) {
            this.tryGetAllSPLinks();
        }
    };
    LinkPlugin.prototype.getAllSPLinks = function () {
        trace.info('processSPLinks');
        this.pendingSPLinksTask = null;
        getAllSharePointLinks(this.editor, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler);
    };
    LinkPlugin.prototype.isSharingLink = function (anchorId) {
        if (!anchorId || anchorId === '') {
            return false;
        }
        return !!getSharingLink(anchorId);
    };
    LinkPlugin.prototype.dispose = function () {
        if (this.onCutDisposer) {
            this.onCutDisposer();
            this.onCutDisposer = null;
        }
        if (this.pendingSPLinksTask) {
            clearTimeout(this.pendingSPLinksTask);
            this.pendingSPLinksTask = null;
        }
        this.editor = null;
        this.scrollAdapter.removeScrollEventListener(this.onScrollOrResize);
        window.removeEventListener(RESIZE_EVENT_NAME, this.onScrollOrResize);
        if (getNumberOfSharingLinks() > 0) {
            removeLinkContextMenu();
        }
    };
    return LinkPlugin;
}());
export default LinkPlugin;
//# sourceMappingURL=LinkPlugin.js.map